import { DollarSignCurrenciesEnum, ZeroDecimalCurrenciesEnum } from '@landr/core.models';

export default class Price {
    value: any;
    currencyCode: string;
    currencySymbol: string;
    discount: number;
    discountKind: string;
    cycleOrder: any;
    kind: string;
    discountedPlans: any;

    constructor(input: any = null) {
        input = input || {};

        this.value = input.feeValue || input.value;
        this.currencyCode = input.currencyCode;
        this.currencySymbol = input.currencySymbol;

        this.discount = input.discount;
        this.discountKind = input.discountKind;
        this.cycleOrder = input.cycleOrder;
        this.kind = input.kind;

        if (input.feePolicy) {
            this.kind = input.feePolicy.policyKind;
            this.discountedPlans = input.feePolicy.policyValues;
        }
    }

    /**
     *  This function check if the countryCode match de zeroDecimalCurrencies countries
     *
     * @returns {boolean}
     * @private
     */
    // TODO: Should be done as getter to be able to send them from Falcor side too
    isZeroDecimalCurrency(): boolean {
        const Ccode = this.currencyCode ? this.currencyCode : '';

        return Ccode in ZeroDecimalCurrenciesEnum;
    }

    /**
     *  This function check if the currency match the $ sign currencies
     *
     * @returns {boolean}
     * @private
     */
    isDollarSignCurrency(): boolean {
        const Ccode = this.currencyCode ? this.currencyCode : '';

        return Ccode in DollarSignCurrenciesEnum;
    }
}
